export enum ConvertionStep {
  profile,
  seminar,
}
